import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import alertService from '../services/alert.service'
import routeUtil from '../utils/route.util'
import { CaseData } from './inventoryCase.api'
import { ItemData } from './item.api'
import { MetadataData } from './metadata.api'
import { PalletData, PalletStatus } from './pallet.api'
import { PurchaseOrderData } from './purchaseOrder.api'
import { UserData } from './user.api'
import { WorkOrderData } from './workOrder.api'
import { ReportPaginateResponseData } from '../utils/reportPaginate.util'
import { Markup as LabelMarkup } from '../views/LabelBuilder/LabelBuilder.slice'

type InventoriableType = 'workOrder' | 'purchaseOrder'
type InventoriableData = WorkOrderData | PurchaseOrderData
export type InventoryLabelPrintType = 'caseOnly' | 'withPallet'

export interface InventoryData {
  id: number
  siteId: number
  inventoriableId: number
  itemId: number
  createdBy: number
  deletedBy?: number
  inventoriableType: InventoriableType
  quantity: number
  note?: string
  deletedAt?: string
  createdAt: string
  isDeleted: boolean
  inventoriable?: InventoriableData
  item?: ItemData
  metadatas?: MetadataData[]
  cases?: CaseData[]
  createdUser?: UserData
  pallets?: PalletData[]
}

export interface InventoryProducedStatusResponse {
  daily: {
    quantity: number
    average: number
  }
  weekly: {
    quantity: number
    average: number
  }
  monthly: {
    quantity: number
    average: number
  }
}

export interface InventoryCreateMetadata {
  metaId: number
  value: string
}

export interface InventoryCreateRequest {
  workOrder?: number
  quantity?: number
  reference?: string
  metadatas?: InventoryCreateMetadata[]
  qpc?: number
  latitude?: number
  longitude?: number
}

export interface InventoryReportExportRequest {
  startAt?: string
  endAt?: string
  location?: number
  item?: number
  history?: boolean
  status?: PalletStatus
}

export interface InventoryReportPaginateRequest
  extends InventoryReportExportRequest, PaginateRequest {}

type InventoryReportPaginateResponse = PaginateResponse<ReportPaginateResponseData[]>

const routes = {
  producedStatus: '/inventories/produced/status',
  printPallets: '/inventories/{id}/pallets/print',
  printCases: '/inventories/{id}/cases/print',
  printLabels: '/inventories/{id}/labels/print',
  create: '/inventories',
  exportReport: '/inventories/report/export',
  paginateReport: '/inventories/report/paginate'
}

export default {
  producedStatus (callback: ResponseCallback<InventoryProducedStatusResponse>) {
    api.get(routes.producedStatus, {}, callback)
  },

  printPallets (id: number, callback: ResponseCallback<string>) {
    alertService.info('Pallet label generating...')
    const url = routeUtil.replaceParams(routes.printPallets, { id })
    api.get(url, {}, callback)
  },

  printCases (id: number, callback: ResponseCallback<LabelMarkup[]>) {
    alertService.info('Case labels generating...')
    const url = routeUtil.replaceParams(routes.printCases, { id })
    api.get(url, {}, callback)
  },

  printLabels (id: number, callback: ResponseCallback<LabelMarkup[]>) {
    alertService.info('Pallet and case labels generating...')
    const url = routeUtil.replaceParams(routes.printLabels, { id })
    api.get(url, {}, callback)
  },

  create (
    payload: InventoryCreateRequest,
    callback: ResponseCallback<InventoryData>
  ) {
    api.post(routes.create, payload, callback)
  },

  exportReport (
    payload: InventoryReportExportRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.post(routes.exportReport, payload, callback)
  },

  paginateReport (
    payload: InventoryReportPaginateRequest,
    callback: ResponseCallback<InventoryReportPaginateResponse>
  ) {
    api.post(routes.paginateReport, payload, callback)
  }
}
